import {
  Box,
  Button,
  Divider,
  Flex,
  Group,
  Loader,
  Paper,
  ScrollArea,
  Space,
  Stack,
  Text,
  Image,
  ActionIcon,
  Tooltip,
} from "@mantine/core";
import useMeter from "../../hooks/useMeter";
import { MeterReturnType } from "../../types";
import { getDayAbbreviation, getShortDate } from "../../utils/date";
import CustomBarChart from "../../components/charts/CustomBarChar";
import CustomLineChart from "../../components/charts/CustomLineChart";
import { IconX } from "@tabler/icons-react";
import { METER_SIDEBAR_SELECTOR } from "../../constants"

type MeterOverviewProps = {
  meter: MeterReturnType;
  close: () => void;
};

export default function MeterOverview({ meter, close }: MeterOverviewProps) {
  const {
    loading,
    weeklyConsumption,
    loadingDailyConsumption,
    handleEntrySelect,
    dailyConsumption,
    setMeterSidebarSelector,
    selectedEntryId,
  } = useMeter(meter?.meterSerialNo);

  return (
    <Box>


      <Group justify="space-between">

        <Image
          src={"../assets/images/tap-icon.png"}
          alt="tap"
          width={50}
          height={50}
        />

        <Group justify="flex-end">
          <Tooltip label={"Close"}>
            <ActionIcon color="pink" size={"sm"} onClick={close}>
              <IconX />
            </ActionIcon>
          </Tooltip>
        </Group>
      </Group>

      <Text size="lg" fw={600} c={"dimmed"}>
        Meter Serial: {meter.meterSerialNo}
      </Text>

      <Divider my={"md"} size={"md"} color="darkblue" />
      {loading ? (
        <Group justify="center" my={"md"}>
          <Loader size={"sm"} />
          <Text>Loading...</Text>
        </Group>
      ) : (
        <ScrollArea h={"80vh"}>
          <Stack>
            <Paper radius={"md"} withBorder shadow="sm" p="md">
              <CustomBarChart
                data={weeklyConsumption?.map((item) => ({
                  name: getDayAbbreviation(item.deviceTime),
                  date: getShortDate(item.deviceTime),
                  consumption: item.consumption,
                  entryId: item.entryID,
                }))}
                handleEntrySelect={handleEntrySelect}
                selectedEntryId={selectedEntryId}
              />
            </Paper>
            {/* <Paper radius={"md"} px={"lg"} py={"xs"} bg={"#f5f9fd"}>
              <Group justify="space-between">
                <div>
                  <Text>Last billed</Text>
                  <Text size="xs">1st Mar 2024</Text>
                  <Button size="xs" mt={15} bg={"#3164f4"}>
                    Bill Account
                  </Button>
                </div>
                <Stack gap={0} align="flex-end">
                  <Text size="xs" c={"#79c3ce"} fw={500}>
                    History
                  </Text>
                  <Text size={"35px"} c={"#79c3ce"}>
                    3 units
                  </Text>
                  <Text size="xs" mt={10}>
                    30 Aug 2024
                  </Text>
                </Stack>
              </Group>
            </Paper> */}
            <Flex direction={"column"} align={"flex-end"}  mb="md">

              <Button
                size="xs"
                c={"grey"}
                px={10}
                py={0}
                w={"fit-content"}
                variant="outline"
                style={{ borderColor: "grey" }}
                onClick={() => {
                  setMeterSidebarSelector(
                    METER_SIDEBAR_SELECTOR.meterPayloadDetails,
                    METER_SIDEBAR_SELECTOR.meterOverview
                  );
                }}
              >
                All Readings
              </Button>
            </Flex>
            <Paper radius={"md"} withBorder shadow="sm" p="md">
              <Text fw={600} c={"lightblue"} ta={"center"}>
                {dailyConsumption.length <= 24
                  ? "24 Hour"
                  : dailyConsumption.length <= 48
                  ? "48 Hour"
                  : "96 Hour"}{" "}
                Delta Consumption
              </Text>
              <Text size="xs" c="dimmed" ta="center">
                {dailyConsumption.length} hourly readings
              </Text>
              <Space h="xs" />
              {loadingDailyConsumption ? (
                <Group justify="center" my={"md"}>
                  <Loader size={"sm"} />
                  <Text>Loading...</Text>
                </Group>
              ) : null}

              <CustomLineChart data={dailyConsumption} />
            </Paper>
          </Stack>
        </ScrollArea>
      )}
    </Box>
  );
}
